import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-898bb44c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "asDropDown_selectedItem"
}
const _hoisted_2 = {
  key: 1,
  class: "asDropDown_placeholder"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "asDropDown_icon" }, null, -1))
const _hoisted_4 = {
  class: "asDropDown_menu",
  role: "listbox",
  tabindex: "0"
}
const _hoisted_5 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["asDropDown", _ctx.additionalClasses])
  }, [
    _createElementVNode("div", {
      class: "asDropDown_input",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onShowMenu && _ctx.onShowMenu(...args)))
    }, [
      (_ctx.selectedItem)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.selectedItem.text), 1))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.placeholder), 1)),
      _hoisted_3
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, key) => {
        return (_openBlock(), _createElementBlock("div", {
          key: key,
          class: _normalizeClass(["asDropDown_menu_item", {
          '-selected': _ctx.modelValue === item.value
        }]),
          onClick: ($event: any) => (_ctx.onSelectItem(item.value))
        }, _toDisplayString(item.text), 11, _hoisted_5))
      }), 128))
    ], 512), [
      [_vShow, _ctx.isShowMenu]
    ])
  ], 2))
}